





























































import RandomChart from '@/components/Statistics/RandomChart.vue'
import Card from '@/components/Card.vue'
import TopUpFilter from '@/components/Services/TopUps/TopUpFilter.vue'
import { reportMixin } from '@/utils/mixins/reportMixin'
import ActionButton from '@/components/ActionButton.vue'
import { getReport } from '@/api/Topup/topup.api'
import { ChartData } from 'chart.js'
import moment from 'moment'
import ReportChart from '@/components/Statistics/ReportChart.vue'
import { Report } from '@/utils/interfaces/topup.interface'
import FlatCard from '~/components/FlatCard.vue'
import TextButton from '~/components/TextButton.vue'

export default reportMixin.extend({
  components: {
    RandomChart: RandomChart,
    appCard: Card,
    appTopUpFilter: TopUpFilter,
    appActionButton: ActionButton,
    appReportChart: ReportChart,
    FlatCard,
    TextButton,
  },
  data() {
    return {
      reports: [
        { name: this.$t('earnings'), color: 'info', value: 0 },
        { name: this.$t('cost'), color: 'accent', value: 0 },
        {
          name: this.$t('charged'),
          color: 'secondary',
          value: 0,
        },
      ],
      loading: false,
      filter: {},
      data: {} as ChartData,
      report: {} as Report,
      selectedCurrency: 'USD' as 'CUP' | 'USD',
    }
  },
  computed: {
    updatedData(): ChartData {
      const data = this.report
      if (!data.labels) return {} as ChartData
      const newData = {
        labels: data.labels.map(date =>
          moment(date).format('ddd, MMM DD YYYY'),
        ),
        datasets: [
          {
            label: this.$t('topup.topup') + 's',
            data: data.topups,
            borderColor: this.$vuetify.theme.themes.light.accent as string,
            fill: false,
          },
          {
            label: this.$t('earnings') as string,
            data: data[this.selectedCurrency].earnings,
            borderColor: this.$vuetify.theme.themes.light.success as string,
            fill: false,
          },
        ],
      }
      this.reports[0].value = data.totals[this.selectedCurrency].earnings
      this.reports[1].value = data.totals[this.selectedCurrency].total_cost
      this.reports[2].value = data.totals[this.selectedCurrency].total_price
      return newData
    },
  },
  methods: {
    async getReport() {
      try {
        this.loading = true
        await this.generateReport(this.filter)
      } finally {
        this.loading = false
      }
    },
    newFilter(filter: any) {
      this.filter = filter
      this.getReportData()
    },
    async getReportData() {
      const response = await getReport(this.filter)
      moment.locale(this.$store.getters.profile.lang)
      this.report = response.data
    },
  },
  async mounted() {
    this.getReportData()
  },
})
